import styled from 'styled-components';

interface DropdownMenuProps {
  top?: number;
  left?: number;
  width?: number;
  direction?: 'up' | 'down';
}

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const DropdownIcon = styled.img`
  width: 16px;
  height: 16px;
  opacity: 0.7;
`;

export const DropdownMenu = styled.div<DropdownMenuProps>`
  position: fixed;
  top: ${({ top }) => (typeof top === 'number' ? `${top}px` : 'unset')};
  left: ${({ left }) => (typeof left === 'number' ? `${left}px` : 'unset')};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  z-index: 2147483647;
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  min-width: unset;
  width: auto;
`;

export const DropdownMenuPanel = styled.div`
  background-color: white;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  padding: 8px 0;
`;

export const DropdownItem = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #303030;
  background-color: ${({ $active }) => ($active ? '#f5f5f5' : 'transparent')};

  &:hover {
    background-color: #f5f5f5;
  }

  svg {
    color: #666666;
    flex-shrink: 0;
  }
`;

export const SubMenu = styled.div`
  background-color: white;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 190px;
  padding: 4px 0;
`;

export const SubMenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }
`;
